import { DeviceLastCommand } from '@iot-platform/models/common';
import { Observable } from 'rxjs';

export abstract class AbstractDeviceCommandService<T> {
  // API returns 204/empty body when no last command exists for the device
  abstract getLastCommandStatus(device: T): Observable<DeviceLastCommand | null>;
}
